// material
import { experimentalStyled as styled } from '@material-ui/core/styles'
import { Grid, Container } from '@material-ui/core'
// components
import Page from '../components/Page'
import FreeDemoForm from 'src/components/_external-pages/free-demo/FreeDemoForm'
import FreeDemoLanding from 'src/components/_external-pages/landing/FreeDemoLanding'
import { motion } from 'framer-motion'
import { varFadeInUp } from 'src/components/animate'

// ----------------------------------------------------------------------

const RootStyle = styled(Page)({
  height: '100%',
})

const ContentStyle = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: theme.palette.background.default,
}))


// ----------------------------------------------------------------------

export default function FreeDemo() {
  return (
    <RootStyle title="Free Demo | Wise AI">
      <FreeDemoLanding />
      <ContentStyle>
        <Container sx={{ mb: 4, }}>
          <FreeDemoForm />
        </Container>
      </ContentStyle>
    </RootStyle>
  )
}
